import { i18n } from '@fs/zion-locale'

export default {
  imageQualityIssue: () => i18n.t('imageQualityAudit.ImageQualityIssue', 'Image Quality Issue'),
  imageQualityIssueForItem: (itemNumber) =>
    i18n.t('imageQualityAudit.imageQualityIssueForItem', 'Image Quality issue for {itemNumber}', { itemNumber }),
  nextImage: () => i18n.t('imageQualityAudit.nextImage', 'Next Image'),
  previousImage: () => i18n.t('imageQualityAudit.previousImage', 'Previous Image'),
  submitAudit: () => i18n.t('imageQualityAudit.submitAudit', 'Submit Audit'),
  imageGroupNumber: () => i18n.t('imageQualityAudit.imageGroupNumber', 'Image Group Number'),

  overUnderExposed: () => i18n.t('imageQualityAudit.overUnderExposed', 'Overexposed/Underexposed'),
  defective: () => i18n.t('imageQualityAudit.defective', 'Defective'),
  duplicate: () => i18n.t('imageQualityAudit.duplicate', 'Duplicate'),
  extraMaterialInFrame: () => i18n.t('imageQualityAudit.extraMaterialInFrame', 'Extra Material in Frame'),
  improperlyCropped: () => i18n.t('imageQualityAudit.improperlyCropped', 'Improperly Cropped'),
  informationObscured: () => i18n.t('imageQualityAudit.informationObscured', 'Information Obscured'),
  missingPages: () => i18n.t('imageQualityAudit.missingPages', 'Missing Pages, Documents, or Attachments'),
  motionBlurOrOutOfFocus: () => i18n.t('imageQualityAudit.motionBlurOrOutOfFocus', 'Motion Blur or Out of Focus'),
  other: () => i18n.t('imageQualityAudit.other', 'Other Reason for Retake'),
  optional: () => i18n.t('imageQualityAudit.optional', 'optional'),
  multiple: () => i18n.t('imageQualityAudit.multipleNaturalGroups', 'Multiple Natural Groups'),
  reflections: () => i18n.t('imageQualityAudit.reflections', 'Reflections'),
  userEnteredIssue: () => i18n.t('imageQualityAudit.userEnteredIssue', 'User-entered Issue'),
  wrongCaptureMode: () => i18n.t('imageQualityAudit.wrongCaptureMode', 'Wrong Capture Mode'),
  wrongImageOrientation: () => i18n.t('imageQualityAudit.wrongImageOrientation', 'Wrong Image Orientation'),
  skewed: () => i18n.t('imageQualityAudit.skewed', 'Skewed'),

  imageQualityAudit: () => i18n.t('imageQualityAudit.imageQualityAudit', 'Image Quality Audit'),
  backToAuditList: () => i18n.t('imageQualityAudit.backToAuditList', 'Back to Audit List'),
  suggestNewAuditPercentage: () =>
    i18n.t('imageQualityAudit.suggestNewAuditPercentage', 'Suggest New Audit Percentage'),
  imageQualityStandards: () => i18n.t('imageQualityAudit.imageQualityStandards', 'Image Quality Standards'),
  reviewTheseImages: (number) =>
    i18n.t(
      'imageQualityAudit.reviewTheseImages',
      'Please review the {number} randomly selected images required for audit:',
      { number }
    ),
  imageNumber: (number) => i18n.t('imageQualityAudit.imageNumber', 'Image {number}', { number }),
  describeTheIssue: () => i18n.t('imageQualityAudit.describeTheIssue', 'Please describe the issue'),
  suggestAChange: () => i18n.t('imageQualityAudit.suggestAChange', 'Suggest a Change'),
  submit: () => i18n.t('imageQualityAudit.submit', 'Submit'),
  decreasePercentage: () => i18n.t('imageQualityAudit.decreasePercentage', 'Decrease Percentage'),
  increasePercentage: () => i18n.t('imageQualityAudit.increasePercentage', 'Increase Percentage'),
  additionalNotes: () => i18n.t('imageQualityAudit.additionalNotes', 'Additional notes (optional)'),
  knownIssueHeader: () => i18n.t('imageQualityAudit.knownIssueHeader', 'Known Folder Quality Issues'),

  copyImageNumberClipboardSuccess: () =>
    i18n.t('imageQualityAudit.copiedToClipboard', 'Image group number copied to clipboard.'),
  copyImageNumberClipboardError: () =>
    i18n.t(
      'imageQualityAudit.copyToClipboardError',
      'There was an error copying the image group number to the clipboard.'
    ),
  copyImageNumberClipboardTooltip: () => i18n.t('imageQualityAudit.copyImageGroupNumber', 'Copy Image Group Number'),
  searchImageLinkTooltip: () => i18n.t('imageQualityAudit.searchImageLinkTooltip', 'Search Image Group Number'),
  addIssueToItem: (number) =>
    i18n.t('imageQualityAudit.addImageQualityIssueForItem', 'Select for Image {number}', { number }),
  addIssueToImage: () => i18n.t('imageQualityAudit.addImageQualityIssue', 'Add Image Quality Issue'),
  editImageQualityIssues: () => i18n.t('imageQualityAudit.editImageQualityIssues', 'Edit Image Quality Issues'),
  cancel: () => i18n.t('common-ui:cancel.action', 'Cancel'),
  save: () => i18n.t('common-ui:save.action', 'Save'),

  atLeastOneIssueMessage: () =>
    i18n.t('cameraOperatorFeedback.atLeastOneIssue', 'You must select at least one image quality issue.'),
}
